<template>
  <div class="d-inline pr-1" :style="{ color: activeColor, fontSize: fontSize + 'px', opacity: opacity + '%' }">
    <slot/>
  </div>

</template>
<script>
export default {
  name: 'icon-base',
  components: {},
  props: {
    fontSize: {
      type: Number,
      default: 25
    },
    activeColor: {
      type: String,
      default: 'inherit'
    },
    opacity: {
      type: Number,
      default: 100
    }
  },
};
</script>
<style></style>
